<script>
import { mapActions, mapState, mapMutations } from "vuex";
import NavigationWrapper from "@/components/NavigationWrapper";

export default {
  // Included components
  components: {
    NavigationWrapper,
  },

  computed: {
    // Only pending invitations
    pendingInvitations() {
      return Object.values(this.invitations).filter(
        (invitation) => !invitation.accepted && !invitation.rejected
      );
    },

    // Mapped vuex state
    ...mapState(["invitations"]),
  },

  // When the component is created, get the invitations from the API
  async created() {
    await this.getInvitations([
      "id,rejected,accepted,created,created_by.handle,role.name",
    ]);
  },

  methods: {
    // Accept the invitation and redirect to the overview page
    // async accept(invitationId) {
    //   await this.acceptInvitation(invitationId);
    //   await await Promise.all([
    //     this.getTeams(),
    //     this.getPermissions(),
    //     this.getAccountRoles()
    //   ]);
    //   this.setActiveTeamId(this.invitations[invitationId].team.id);
    //   this.$router.push("/");
    // },

    view(invitationId) {
      this.$router.push("/invitations/" + invitationId);
    },

    // Mapped vuex actions
    ...mapMutations(["setActiveTeamId"]),
    ...mapActions([
      "getInvitations",
      "acceptInvitation",
      "getTeams",
      "getPermissions",
      "getAccountRoles",
    ]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/account">Account</b-breadcrumb-item>
      <b-breadcrumb-item active>Invitations</b-breadcrumb-item>
    </template>
    <div class="mb-3">
      <h1>Invitations</h1>
    </div>
    <b-card
      class="text-center py-5"
      v-if="pendingInvitations.length === 0"
      key="none"
    >
      <b-card-title>No Pending Invitations</b-card-title>
      <b-card-text>
        To join a team, ask a member of the team to invite you
      </b-card-text>
    </b-card>
    <b-card v-else class="Card-table" key="some">
      <b-card-text>
        <b-table
          responsive
          small
          :fields="[
            {
              key: 'team.name',
              label: 'Team name',
              sortable: true,
            },
            {
              key: 'role.name',
              label: 'Role',
              sortable: true,
            },
            {
              key: 'created_by',
              label: 'Invited by',
              formatter(value, key, item) {
                return `${value.name || '@' + value.handle}`;
              },
              sortable: true,
            },
            {
              key: 'accept',
              label: 'Invite',
              thStyle: { width: '15%' },
            },
          ]"
          :items="pendingInvitations"
        >
          <template #cell(accept)="data">
            <a href="#" @click="view(data.item.id)">View Invite</a>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
  </NavigationWrapper>
</template>
